var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrade4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_88161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2255 12.4996H1.7759C1.50917 12.4996 1.29297 12.2834 1.29297 12.0167V4.5919L6.00068 1.50098L10.7084 4.5919V12.0167C10.7084 12.2834 10.4922 12.4996 10.2255 12.4996Z",
    fill: "#E9F0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00062 1.50098L5.63843 1.73879L9.98397 4.59192V12.0167C9.98397 12.2834 9.76776 12.4996 9.50104 12.4996H10.2254C10.4922 12.4996 10.7084 12.2834 10.7084 12.0167V4.5919L6.00062 1.50098Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5448 5.05293C11.4591 5.05295 11.3724 5.02876 11.2954 4.97817L6.0007 1.50187L0.706061 4.97817C0.224608 5.29422 -0.287705 4.53868 0.206353 4.2143L5.75086 0.573978C5.9011 0.475341 6.10033 0.475341 6.25057 0.573978L11.7951 4.2143C12.167 4.45854 11.9838 5.05293 11.5448 5.05293Z",
    fill: "#FF567B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00697 6.42261C6.93363 4.56964 9.41894 5.70189 8.82924 7.64354C8.25383 9.53809 6.00083 10.5696 6.00083 10.5696C6.00083 10.5696 3.74784 9.53809 3.17243 7.64354C2.58273 5.70189 5.06801 4.56964 5.9947 6.42261H6.00697Z",
    fill: "#FF567B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90566 5.56439C7.62773 5.81725 8.17493 6.6171 7.8633 7.64322C7.45677 8.98178 6.21295 9.88936 5.51782 10.3069C5.80656 10.4803 6.00075 10.5693 6.00075 10.5693C6.00075 10.5693 8.25377 9.53777 8.82915 7.64322C9.27366 6.17962 7.97097 5.17624 6.90566 5.56439Z",
    fill: "#FF567B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_88161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade4);
export default __webpack_public_path__ + "static/media/grade4.dec2f30fe8240a93eb8f2d570253bb19.svg";
export { ForwardRef as ReactComponent };